<be-dialog-shell [title]="title" (close)="closeDialog()" [closeButton]="!saving"
                 [showFooter]="showSaveAndCancelButtons" [className]="tags.size > 1 ? 'fixed-size' : null">
    <form autocomplete="off" (submit)="$event.preventDefault();" [formGroup]="formGroup">
        <mat-tab-group *ngIf="tags.size > 1">
            <mat-tab *ngFor="let tag of tags" [label]="tag">
                <div class="tab-content">
                    <be-edition-tab
                            *ngIf="['Principal', 'Teléfonos', 'Comercial asociado', 'Usuario'].includes(tag)"
                            [propertiesToShow]="colsForTag(tag)" [formGroup]="formGroup"
                            [formManager]="formManager"
                            [cien]="tag !== 'Principal'"></be-edition-tab>

                    <ng-container *ngIf="['Direcciones'].includes(tag)">
                        <be-edition-tab [propertiesToShow]="colsForTag(tag)" [formGroup]="formGroup"
                                        [formManager]="formManager" [cien]="true"></be-edition-tab>

                        <button mat-flat-button color="primary"
                                *ngIf="mostrarBotonDireccionesIguales() && !allFieldsDisabled"
                                (click)="direccionesIguales()"
                                [disabled]="modified && !formGroup.valid">Las dos direcciones son iguales
                        </button>
                    </ng-container>

                    <ng-container *ngIf="['Clientes asociados'].includes(tag)">
                        <be-edition-tab [propertiesToShow]="colsPermisoAsociados()" [formGroup]="formGroup"
                                        [formManager]="formManager" [cien]="true"></be-edition-tab>

                        <div class="tabla-scroll" arrastrarScroll>
                            <table class="tabla-asociados" *ngIf="dataSourceAsociados?.length">
                                <thead>
                                <tr>
                                    <th>Clínica</th>
                                    <th>CIF/NIF</th>
                                    <th>Email</th>
                                    <th>Baja</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let asociado of dataSourceAsociados">
                                    <td>{{ asociado.denominacionSocial }}</td>
                                    <td>{{ asociado.cifNif }}</td>
                                    <td>{{ asociado.email }}</td>
                                    <td>{{ asociado.baja ? 'Sí' : 'No' }}</td>
                                    <td class="centrado">
                                        <button mat-icon-button type="button" (click)="editarAsociado(asociado)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="aviso" *ngIf="!dataSourceAsociados?.length">
                            <mat-icon aria-hidden="true">info</mat-icon>
                            Todavía no hay clientes asociados.
                        </div>
                        <button mat-raised-button type="button" (click)="anadirAsociado()">
                            Añadir cliente asociado
                        </button>
                    </ng-container>

                    <ng-container *ngIf="['Descuentos'].includes(tag)">
                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('descuentosMetodoFabricacion')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>
                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('descuentosGenerales')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <div class="aviso">
                            <mat-icon aria-hidden="true">info</mat-icon>
                            Los descuentos por método de fabricación y material se aplicarán a la hora de confirmar un
                            pedido,
                            según el
                            método de fabricación y material seleccionado.
                        </div>

                        <div class="aviso">
                            <mat-icon aria-hidden="true">info</mat-icon>
                            Los descuentos genéricos se eligen al facturar a un cliente. Los que tengan marcado
                            "Aplicar automáticamente al facturar" aparecerán ya añadidos, y se pueden quitar antes de crear la factura.
                        </div>

                    </ng-container>

                    <ng-container *ngIf="['Facturación'].includes(tag)">
                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('facturaSimplificada')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('diaMesParaCargo')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('cuentasBancariasCliente')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('formasPagoDisponibles')" [formGroup]="formGroup"
                                        [formManager]="formManager" [filters]="clienteFilter">
                        </be-edition-row>

                        <div class="boton-mandato">
                            <button mat-flat-button (click)="generarMandato()" [disabled]="allFieldsDisabled"
                                    [class]="model.mandato ? 'creado' : 'no-creado'">
                                <mat-icon>receipt</mat-icon>
                                Mandato SEPA
                            </button>
                        </div>

                    </ng-container>
                </div>
            </mat-tab>
        </mat-tab-group>
        <be-edition-tab *ngIf="tags.size <= 1"
                        [propertiesToShow]="colsToShow" [formGroup]="formGroup"
                        [formManager]="formManager"></be-edition-tab>
    </form>
    <dialog-actions>
        <button mat-flat-button color="primary" *ngIf="puedeCrearAcceso() && !esComercial()"
                (click)="crearAcceso()" [disabled]="saving || !formGroup.valid || !nombreORazonSocialValidos">
            <mat-icon>person_add</mat-icon>
            Crear acceso
        </button>
        <mat-slide-toggle *ngIf="accesoMensajes" class="mensajes-cliente" color="primary"
                          [checked]="accesoMensajes.activos" [disabled]="cambiandoMensajes || !accesoMensajes.conUsuario"
                          [matTooltip]="accesoMensajes.conUsuario ? 'Si el cliente puede usar los mensajes con CNC. Lo nota al volver a entrar.' : 'El cliente aún no tiene usuario'"
                          (change)="cambiarMensajes($event)">Mensajes activados</mat-slide-toggle>
        <button mat-flat-button color="primary" *ngIf="puedeReenviarActivacion()"
                (click)="reenviarActivacion()" [disabled]="saving">
            <mat-icon>mail</mat-icon>
            Reenviar activación
        </button>
        <button mat-button class="btn_cancelar" (click)="closeDialog()" [disabled]="saving">Cancelar</button>
        <button mat-flat-button class="btn_guardar" *ngIf="shouldManageSaving && modified" (click)="acceptDialog()"
                color="primary"
                [disabled]="!formGroup.valid || !nombreORazonSocialValidos || saving">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
        <button mat-button *ngIf="!(shouldManageSaving && modified)" (click)="acceptDialog()"
                [disabled]="modified && (!formGroup.valid || !nombreORazonSocialValidos)">Aceptar
        </button>
    </dialog-actions>
</be-dialog-shell>
